import gql from 'graphql-tag';

import { contentUnifiedContentFragment } from './fragments/contentUnifiedContentFragment.fragment';
import { contentUnifiedSpaceFragment } from './fragments/contentUnifiedSpaceFragment.fragment';
import { contentUnifiedContentFragmentWithImports } from './fragments/contentUnifiedContentFragmentWithImports.fragment';

export const ContentUnifiedWithSpaceKeyQuery = gql`
	query ContentUnifiedWithSpaceKeyQuery(
		$spaceKey: String!
		$versionOverride: Int
		$isSSR: Boolean = false
		$useNewContentTopper: Boolean = false
		$preloadLabels: Boolean = false
	) @SLA {
		spaceHomepage(spaceKey: $spaceKey, version: $versionOverride) {
			...contentUnifiedContentFragment
		}
		space(key: $spaceKey) {
			...contentUnifiedSpaceFragment
		}
	}
	${contentUnifiedContentFragment}
	${contentUnifiedSpaceFragment}
`;

// TODO: (rwang8) remove this when tidying fg 'cc_importer_admin_enable_import_feedback_banner'
export const ContentUnifiedWithSpaceKeyQueryWithImports = gql`
	query ContentUnifiedWithSpaceKeyQuery(
		$spaceKey: String!
		$versionOverride: Int
		$isSSR: Boolean = false
		$useNewContentTopper: Boolean = false
		$preloadLabels: Boolean = false
	) @SLA {
		spaceHomepage(spaceKey: $spaceKey, version: $versionOverride) {
			...contentUnifiedContentFragment
		}
		space(key: $spaceKey) {
			...contentUnifiedSpaceFragment
		}
	}
	${contentUnifiedContentFragmentWithImports}
	${contentUnifiedSpaceFragment}
`;
